/**
 * package: com.inq.flash.client.data
 * class: ChatCommunicationOpenerMessage
 * @extends com.inq.flash.client.data.ChatCommunicationMessage 
 * @constructor
 */
com.inq.flash.client.data.ChatCommunicationOpenerMessage = function(chat,text,agentAlias, sequenceNumber) {
	com.inq.flash.client.data.ChatCommunicationMessage.call(this,chat,text);
	this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OPENER);
	this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_AGENT_ALIAS, agentAlias);

	/**
	 * We send the chat openers to the Chat Router when a customer sends his first message, along with his first message.
	 * We need to attach the opener sequence number to the opener message objects we're sending to the Chat Router.
	 * This way the backend will send us back the opener sequence number with the response so we can display the openers in order.
	 * We need this because some clients have more than one opener message, but when a customer sends his first message
	 * we send all openers to the Chat Router in separate AJAX calls at the same time, along with his first message. If the backend
	 * processes the openers out of order it will return it back to us out of order. This way even if it returns it to us out of order
	 * we can still determine which opener should display first when presenting to customer. This is referred to as "position" in
	 * ChatTextArea.prototype.addOpenerScript.
	 */
	this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_LINE_NR, sequenceNumber);
};
$hxClasses['com.inq.flash.client.data.ChatCommunicationOpenerMessage'] = com.inq.flash.client.data.ChatCommunicationOpenerMessage;
/** @private @type {Array} */
com.inq.flash.client.data.ChatCommunicationOpenerMessage.__name__ = ["com","inq","flash","client","data","ChatCommunicationOpenerMessage"];
/** @private @type {Function} */
com.inq.flash.client.data.ChatCommunicationOpenerMessage.__super__ = com.inq.flash.client.data.ChatCommunicationMessage;
for(var k in com.inq.flash.client.data.ChatCommunicationMessage.prototype ) com.inq.flash.client.data.ChatCommunicationOpenerMessage.prototype[k] = com.inq.flash.client.data.ChatCommunicationMessage.prototype[k];
/** @type {com.inq.flash.client.data.ChatCommunicationOpenerMessage} */
com.inq.flash.client.data.ChatCommunicationOpenerMessage.prototype.__class__ = com.inq.flash.client.data.ChatCommunicationOpenerMessage;
